import type { LegalBlock } from '../types/content';

export const termsUpdated = 'Última actualización: septiembre de 2026.';

export const terms: LegalBlock[] = [
  {
    title: '1. Titular',
    paragraphs: [
      'Este sitio, las tiendas online enlazadas en esta página y la venta de sus productos son operados por **Massive Faith LLC**, Limited Liability Company registrada en el Estado de Wyoming, Estados Unidos (EIN 39-5048643), con domicilio comercial en **1057 NW 136th Ave, Miami, FL 33182, Estados Unidos**, cuyos miembros son **Alejo Lautaro Martinez Avellaneda** y **Tomas Ivan Martinez Avellaneda**. Contacto: [info@massivefaith.site](mailto:info@massivefaith.site) · [+1 (307) 302-5593](tel:+13073025593).',
    ],
  },
  {
    title: '2. Aceptación',
    paragraphs: [
      'Al hacer una compra en cualquiera de nuestras tiendas aceptás estos Términos y Condiciones, junto con la Política de Reembolsos, la Política de Entrega y la Política de Privacidad publicadas en esta misma página, que forman parte de este acuerdo. Te recomendamos leerlos antes de completar tu pedido.',
    ],
  },
  {
    title: '3. Producto ofrecido',
    paragraphs: [
      'Massive Faith LLC vende un único tipo de producto, íntegramente digital: el **kit de libros digitales «La Ley de Murphy»** (en inglés, «Murphy\'s Law for Kids»), compuesto por 3 libros en PDF con formato de cómic educativo para chicos de 6 a 12 años, y complementos digitales opcionales del mismo tipo. **No se envían productos físicos y no se prestan servicios personalizados, de consultoría ni de asesoramiento individual.**',
    ],
  },
  {
    title: '4. Entrega',
    paragraphs: [
      'Confirmado el pago, el producto se entrega de inmediato por email a la dirección indicada en la compra. Es responsabilidad del cliente ingresar un email válido y revisar la carpeta de correo no deseado. Los detalles están en la [Política de entrega y envíos](#entrega).',
    ],
  },
  {
    title: '5. Precio y forma de pago',
    paragraphs: [
      'Los precios publicados corresponden a **pagos únicos** en dólares estadounidenses (USD). **No vendemos suscripciones ni servicios con renovación automática**, y no hacemos ningún cobro que el cliente no haya autorizado expresamente. Los pagos se procesan a través de plataformas de pago seguras de terceros certificadas PCI-DSS; no almacenamos datos de tarjeta. Los precios promocionales tienen vigencia limitada y el importe final se muestra siempre antes de confirmar el pago. El cargo figura en el extracto bancario del cliente como **MASSIVE FAITH LLC**. Según el banco del cliente, pueden aplicarse cargos por conversión de moneda ajenos a nosotros.',
    ],
  },
  {
    title: '6. Garantía y reembolsos',
    paragraphs: [
      'Todos los productos tienen una **garantía de satisfacción de 30 días** desde la fecha de compra, con devolución del 100 % del importe pagado. Se aplica en su totalidad la [Política de reembolsos, cancelaciones y devoluciones](#reembolsos) publicada en esta página.',
    ],
  },
  {
    title: '7. Propiedad intelectual',
    paragraphs: [
      'Todo el contenido vendido —textos, ilustraciones y archivos descargables— pertenece a Massive Faith LLC o a sus licenciantes, y se entrega al cliente con una licencia de uso **personal, familiar, intransferible y no exclusiva**. Está prohibido revenderlo, redistribuirlo, copiarlo para terceros o publicarlo, total o parcialmente, sin autorización previa y por escrito. El incumplimiento habilita la baja inmediata del acceso sin derecho a reembolso, sin perjuicio de las acciones legales que correspondan.',
    ],
  },
  {
    title: '8. Alcance del contenido y limitación de responsabilidad',
    paragraphs: [
      'Los libros tienen fines educativos y de entretenimiento y están pensados para leerse junto con un adulto. **No reemplazan la educación escolar ni constituyen asesoramiento psicológico, médico, pedagógico ni profesional de ningún tipo**, y no garantizan un resultado específico en el aprendizaje o la conducta de cada chico. La responsabilidad de Massive Faith LLC se limita, en todos los casos, al importe efectivamente pagado por el cliente.',
    ],
  },
  {
    title: '9. Obligaciones del cliente',
    items: [
      'Dar datos verdaderos y un email válido al momento de la compra.',
      'Ser mayor de 18 años. Nuestros productos están dirigidos a chicos, pero el comprador siempre debe ser un adulto.',
      'Usar el material de acuerdo con la ley y con estos Términos.',
      'No compartir los archivos ni los enlaces de descarga con terceros.',
      'Contactar a nuestro soporte antes de iniciar una disputa o contracargo ante su banco.',
    ],
  },
  {
    title: '10. Modificaciones',
    paragraphs: [
      'Massive Faith LLC puede actualizar estos Términos en cualquier momento. La versión aplicable a cada compra es la publicada en esta página al momento de hacerla. Los cambios no afectan compras anteriores.',
    ],
  },
  {
    title: '11. Ley aplicable y contacto',
    paragraphs: [
      'Estos Términos se rigen por las leyes del Estado de Wyoming, Estados Unidos de América, sin perjuicio de los derechos que la normativa de protección al consumidor del país de residencia del cliente le reconozca con carácter obligatorio. Para cualquier consulta, reclamo o para usar tu garantía, escribinos a [info@massivefaith.site](mailto:info@massivefaith.site).',
    ],
  },
];

export const privacy: LegalBlock[] = [
  {
    title: 'Responsable del tratamiento',
    paragraphs: [
      '**Massive Faith LLC**, con domicilio en 1057 NW 136th Ave, Miami, FL 33182, Estados Unidos, y email de contacto [info@massivefaith.site](mailto:info@massivefaith.site).',
    ],
  },
  {
    title: 'Qué datos recopilamos y para qué',
    items: [
      '**Nombre, email y, si lo das, teléfono:** para procesar la compra, entregar el producto, enviar el comprobante y darte soporte.',
      '**Datos de pago:** los procesan directamente nuestros proveedores de pago certificados PCI-DSS. **No almacenamos números completos de tarjeta.**',
      '**Datos de navegación y publicidad:** usamos cookies y píxeles de terceros (por ejemplo, Meta y Google) para medir nuestras campañas publicitarias y mejorar nuestros sitios.',
      '**Datos de menores:** nuestros compradores son adultos. No pedimos ni recopilamos a sabiendas datos personales de chicos.',
    ],
  },
  {
    title: 'Con quién compartimos los datos',
    paragraphs: [
      'Solo con los proveedores necesarios para prestar el servicio: plataformas de comercio electrónico, procesadores de pago, plataformas de entrega de archivos, proveedores de email y plataformas de publicidad. **No vendemos ni cedemos datos personales a terceros para fines ajenos a nuestra actividad.**',
    ],
  },
  {
    title: 'Conservación',
    paragraphs: [
      'Conservamos los datos mientras dure la relación comercial y durante los plazos legales de conservación fiscal y contable aplicables en Estados Unidos.',
    ],
  },
  {
    title: 'Tus derechos',
    paragraphs: [
      'Podés pedir en cualquier momento el acceso, la corrección o la eliminación de tus datos, o la baja de nuestras comunicaciones comerciales, escribiendo a [info@massivefaith.site](mailto:info@massivefaith.site). Respondemos toda solicitud dentro de los 30 días.',
    ],
  },
];

export const englishFacts = [
  { label: 'Legal entity', value: 'Massive Faith LLC — Limited Liability Company registered in the State of Wyoming, USA.' },
  { label: 'EIN', value: '39-5048643' },
  { label: 'Date of formation', value: 'October 23, 2025' },
  { label: 'Business address', value: '1057 NW 136th Ave, Miami, FL 33182, United States.' },
  { label: 'Registered agent', value: 'Registered Agents Inc — 30 N Gould St, Suite R, Sheridan, WY 82801.' },
  { label: 'Members / owners', value: 'Alejo Lautaro Martinez Avellaneda (50%) and Tomas Ivan Martinez Avellaneda (50%).' },
  { label: 'Website', value: 'info.massivefaith.site' },
  { label: 'Support email', value: 'info@massivefaith.site' },
  { label: 'Phone', value: '+1 (307) 302-5593' },
  { label: 'Brands', value: 'Padres Responsables (Spanish) · Responsible Parents (English)' },
  { label: 'Statement descriptor', value: 'MASSIVE FAITH LLC' },
];

export const englishParagraphs = [
  "**What we sell.** Massive Faith LLC sells **one digital product only**: a downloadable kit of three children's books in PDF format, illustrated in an educational comic style, for kids aged 6 to 12. The Spanish edition includes La Ley de Murphy — Habilidades para la Vida, 100.000 Porqués and Liderazgo para Chicos; the English edition includes Murphy's Law for Kids, The Big Book of Why and Leadership Starts Here. The books teach life skills (handling frustration and mistakes, problem solving), general knowledge and leadership. Price: **US$ 18.90, one-time payment**. Optional add-ons of the same kind (digital PDFs) may be offered at checkout and are charged only if the customer explicitly accepts them. Sold exclusively through our own online stores: padresresponsables.com (Spanish) and englishstore.online (English). Customers are adults (parents, relatives and teachers) in Latin America, Spain, the United States, the United Kingdom, Canada, Ireland and New Zealand. **We do not sell or ship physical goods, we do not sell through third-party marketplaces, and we do not provide consulting or any personalized service.**",
  '**Billing model.** One-time payments in USD only. **No subscriptions, no recurring billing, no free trials that convert into charges and no automatic renewals.** The full amount is shown to the customer before checkout. Payments are handled by PCI-DSS certified third-party processors; we do not store card data.',
  '**Delivery.** Instant digital delivery by email (download links to the PDF files), typically within 5 minutes of payment. No shipping costs, no physical shipments, no customs and no delivery delays. If an email fails to arrive, we resolve it within 24 business hours.',
  '**Refunds and cancellations.** A **30-day money-back guarantee applies to every purchase**, with a 100% refund. Customers request it by email to info@massivefaith.site (or by replying to their order confirmation); we acknowledge within 24 business hours and refund to the original payment method within 5 business days. One refund per customer; the refund revokes the license to the files. Since we sell no subscriptions, customers have nothing to cancel to avoid future charges. No physical returns apply.',
  '**Customer support.** Email info@massivefaith.site and phone +1 (307) 302-5593, Monday to Friday, 9:00 to 18:00 (GMT-3). First response within 24 business hours. Support is provided in Spanish and English.',
];
